
(function () {
  "use strict";

  // Birden fazla Shopify slideshow bolumu varsa bu asset iki kez
  // HTML'e eklenebiliyor. Bu guard, ikinci JS calismasinin ayni
  // sliderlari ve video timer'larini tekrar baslatmasini engeller.
  // Tek kontrolcu sayfadaki TUM .slideshow bolumlerini yonetir.
  if (window.__oonoSlideshowControllerInitialized === true) return;
  window.__oonoSlideshowControllerInitialized = true;

  const PHOTO_DURATION = 8000;
  const initialized = new WeakMap();

  function setup(element) {
    if (
      initialized.has(element) ||
      typeof Swiper === "undefined"
    ) return;

    const section = element.closest("section");

    const imageElement = element.querySelector(
      ".slideshow__contents-wrapper"
    );

    const textElement = element.querySelector(
      ".slideshow__tabs-wrapper"
    );

    if (!section || !imageElement || !textElement) return;

    const total = imageElement.querySelectorAll(
      ".slideshow__content"
    ).length;

    if (total <= 1) {
      imageElement.classList.add("no_slideshow");
      textElement.classList.add("no_slideshow");
      return;
    }

    const autoplay =
      element.dataset.autoplay === "true";

    const stopOnHover =
      element.dataset.stopAutoplay === "true";

    const speed = Math.max(
      0,
      Number(element.dataset.speed || 1.1) * 1000
    );

    const effect =
      element.dataset.effect || "slide";

    let imageSwiper;
    let photoTimer = null;
    let photoStartedAt = 0;
    let photoRemaining = PHOTO_DURATION;
    let startFallback = null;
    let active = null;
    let version = 0;
    let hovering = false;
    let disposed = false;

    const isPaused = () =>
      document.hidden || (stopOnHover && hovering);

    const valid = (ticket) =>
      !disposed &&
      imageSwiper &&
      !imageSwiper.destroyed &&
      ticket === version;

    function setProgress(duration) {
      section.style.setProperty(
        "--bullet-duration",
        `${Math.round(duration + speed)}ms`
      );
    }

    function stopPhotoTimer() {
      if (photoTimer !== null) {
        clearTimeout(photoTimer);
      }

      photoTimer = null;
    }

    function stopActive() {
      version += 1;
      stopPhotoTimer();

      if (startFallback !== null) {
        clearTimeout(startFallback);
      }

      startFallback = null;

      if (
        active &&
        typeof active.cleanup === "function"
      ) {
        active.cleanup();
      }

      active = null;
    }

    // =====================================
    // SONRAKİ BANNERA GEÇİŞ
    // =====================================

    function next(ticket) {
      if (
        !valid(ticket) ||
        !autoplay ||
        !active
      ) return;

      if (isPaused()) {
        active.finished = true;
        return;
      }

      const target =
        (imageSwiper.realIndex + 1) % total;

      imageSwiper.slideTo(target, speed);
    }

    // =====================================
    // FOTOĞRAF: 8 SANİYE
    // =====================================

    function startPhoto(duration, ticket) {
      if (!valid(ticket) || !active) return;

      stopPhotoTimer();

      photoRemaining = Math.max(0, duration);

      if (isPaused()) return;

      photoStartedAt = Date.now();

      photoTimer = setTimeout(() => {
        photoTimer = null;
        next(ticket);
      }, photoRemaining);
    }

    // =====================================
    // RESPONSIVE VIDEO SEÇİMİ
    // =====================================

    function selectVideo(slide) {
      const videos = Array.from(
        slide.querySelectorAll("video")
      );

      return videos.find((video) => {
        const style = getComputedStyle(video);

        return (
          video.getClientRects().length > 0 &&
          style.display !== "none" &&
          style.visibility !== "hidden"
        );
      }) || videos[0] || null;
    }

    // =====================================
    // AKTİF SLAYTIN VIDEO KAYNAĞINI YÜKLE
    // Diğer video kaynakları data-src olarak bekler.
    // =====================================

    function loadSelectedVideo(video) {
      let changed = false;

      // The hidden desktop/mobile poster stays in data-poster until
      // its video is actually active. The first hero poster is set
      // synchronously by slideshow.liquid during HTML parsing.
      const poster = video.getAttribute("data-poster");
      if (poster && !video.hasAttribute("poster")) {
        video.setAttribute("poster", poster);
      }

      const videoSrc = video.getAttribute("data-src");
      if (videoSrc) {
        video.setAttribute("src", videoSrc);
        video.removeAttribute("data-src");
        changed = true;
      }

      video.querySelectorAll("source[data-src]").forEach((source) => {
        const url = source.getAttribute("data-src");
        if (!url) return;

        source.setAttribute("src", url);
        source.removeAttribute("data-src");
        changed = true;
      });

      if (changed) video.load();
    }

    // =====================================
    // AKTİF BANNER
    // =====================================

    function activate() {
      if (
        !autoplay ||
        disposed ||
        !imageSwiper ||
        imageSwiper.destroyed
      ) return;

      const slide =
        imageSwiper.slides[imageSwiper.activeIndex];

      if (!slide) return;

      if (active && active.slide === slide) {
        if (!isPaused()) active.resume();
        return;
      }

      stopActive();

      const ticket = version;
      const video = selectVideo(slide);

      setProgress(PHOTO_DURATION);

      // FOTOĞRAF

      if (!video) {
        active = {
          kind: "photo",
          slide,
          finished: false,

          resume: () =>
            startPhoto(photoRemaining, ticket),

          cleanup: () => {}
        };

        photoRemaining = PHOTO_DURATION;

        startPhoto(PHOTO_DURATION, ticket);
        return;
      }

      // =====================================
      // VIDEO AYARLARI
      // =====================================

      // İlk aktif videoyu durdurma.
      // Diğer videoları durdur.

      imageElement.querySelectorAll("video").forEach(
        (other) => {
          other.loop = false;
          other.removeAttribute("loop");

          if (other !== video) {
            other.autoplay = false;
            other.removeAttribute("autoplay");
            other.pause();
          }
        }
      );

      video.loop = false;
      video.removeAttribute("loop");

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      video.playsInline = true;
      video.setAttribute("playsinline", "");

      video.preload = "auto";
      video.autoplay = true;
      video.setAttribute("autoplay", "");

      let playPending = false;
      let retryTimer = null;
      let attempts = 0;
      let cleaned = false;

      const state = {
        kind: "video",
        slide,
        video,
        finished: false,

        resume: () => attemptPlay(),

        cleanup: () => {
          cleaned = true;

          if (retryTimer !== null) {
            clearTimeout(retryTimer);
          }

          video.removeEventListener(
            "ended",
            onEnded
          );

          video.removeEventListener(
            "timeupdate",
            onTimeUpdate
          );

          video.removeEventListener(
            "pause",
            onPause
          );

          video.removeEventListener(
            "canplay",
            attemptPlay
          );

          video.removeEventListener(
            "loadeddata",
            attemptPlay
          );

          video.removeEventListener(
            "loadedmetadata",
            updateDuration
          );

          video.removeEventListener(
            "playing",
            updateDuration
          );

          video.pause();

          video.autoplay = false;
          video.removeAttribute("autoplay");

          try {
            video.currentTime = 0;
          } catch (e) {}
        }
      };

      active = state;

      // =====================================
      // VIDEO SÜRESİ
      // =====================================

      function updateDuration() {
        if (
          Number.isFinite(video.duration) &&
          video.duration > 0
        ) {
          setProgress(video.duration * 1000);
        }
      }

      // =====================================
      // VIDEO BİTİŞİ
      // =====================================

      function onEnded() {
        if (
          valid(ticket) &&
          active === state
        ) {
          next(ticket);
        }
      }

      function onTimeUpdate() {
        if (
          video.ended &&
          valid(ticket) &&
          active === state
        ) {
          next(ticket);
        }
      }

      // =====================================
      // OTOMATİK OYNATMA KONTROLÜ
      // =====================================

      function retry(error) {
        if (
          cleaned ||
          !valid(ticket) ||
          isPaused() ||
          retryTimer !== null
        ) return;

        if (attempts >= 12) {
          console.warn(
            "[Slideshow] İlk video oynatılamadı:",
            error,
            video.currentSrc
          );

          return;
        }

        retryTimer = setTimeout(() => {
          retryTimer = null;
          attemptPlay();
        }, Math.min(1300, 150 + attempts * 120));
      }

      function attemptPlay() {
        if (
          cleaned ||
          !valid(ticket) ||
          active !== state ||
          isPaused()
        ) return;

        if (video.ended) {
          onEnded();
          return;
        }

        if (!video.paused || playPending) {
          return;
        }

        attempts += 1;
        playPending = true;

        let result;

        try {
          result = video.play();
        } catch (error) {
          playPending = false;
          retry(error);
          return;
        }

        Promise.resolve(result)
          .then(() => {
            playPending = false;
            attempts = 0;
            updateDuration();
          })
          .catch((error) => {
            playPending = false;
            retry(error);
          });
      }

      function onPause() {
        if (!video.ended) {
          retry();
        }
      }

      // =====================================
      // VIDEO EVENT LISTENERS
      // =====================================

      video.addEventListener(
        "ended",
        onEnded
      );

      video.addEventListener(
        "timeupdate",
        onTimeUpdate
      );

      video.addEventListener(
        "pause",
        onPause
      );

      video.addEventListener(
        "canplay",
        attemptPlay
      );

      video.addEventListener(
        "loadeddata",
        attemptPlay
      );

      video.addEventListener(
        "loadedmetadata",
        updateDuration
      );

      video.addEventListener(
        "playing",
        updateDuration
      );

      // HTML'de ertelenen kaynakları yalnızca bu aktif videoya bağla.
      // canplay/loadeddata dinleyicileri önceden bağlı olduğundan
      // ilk açılışta otomatik oynatma mantığı aynen çalışır.
      loadSelectedVideo(video);
      updateDuration();

      // İlk yüklemede video zaten oynuyorsa
      // baştan başlatma.
      // Sonraki turlarda cleanup videoyu sıfırlar.

      attemptPlay();
    }

    // =====================================
    // ORİJİNAL SWIPER AYARLARI
    // =====================================

    const swiperParams = {
      speed,
      keyboard: true,
      loop: true
    };

    // =====================================
    // METİN VE SEKME SLIDER
    // =====================================

    const textSwiper = new Swiper(textElement, {
      ...swiperParams,

      spaceBetween: 24,
      direction: "horizontal",
      slidesPerView: "auto",
      allowTouchMove: false,

      breakpoints: {
        990: {
          allowTouchMove: true
        },

        1600: {
          allowTouchMove: false,
          touchRatio: 0,

          keyboard: {
            enabled: false
          }
        }
      },

      on: {
        init() {
          textElement.classList.add("first_step");
        },

        slideChange() {
          textElement.classList.remove(
            "first_step"
          );
        }
      }
    });

    // =====================================
    // ANA BANNER SWIPER
    // =====================================

    imageSwiper = new Swiper(imageElement, {
      ...swiperParams,

      autoplay: false,
      effect,

      pagination: {
        el: element.querySelector(
          ".swiper-pagination"
        ),
        clickable: true
      },

      thumbs: {
        swiper: textSwiper
      },

      on: {
        init() {
          imageElement.classList.add(
            "first_step"
          );

          setProgress(PHOTO_DURATION);
        },

        slideChange() {
          // Start the incoming poster request before the fade completes;
          // the MP4 source still waits until the slide becomes active.
          const incoming = this.slides[this.activeIndex];
          const incomingVideo = incoming && selectVideo(incoming);
          if (incomingVideo) {
            const poster = incomingVideo.getAttribute("data-poster");
            if (poster && !incomingVideo.hasAttribute("poster")) {
              incomingVideo.setAttribute("poster", poster);
            }
          }

          stopActive();

          startFallback = setTimeout(
            activate,
            speed + 80
          );
        },

        slideChangeTransitionEnd() {
          imageElement.classList.remove(
            "first_step"
          );

          if (startFallback !== null) {
            clearTimeout(startFallback);
          }

          startFallback = null;

          activate();
        }
      }
    });

    // =====================================
    // DURAKLATMA / DEVAM ETME
    // =====================================

    function pauseCurrent() {
      if (!active) return;

      if (
        active.kind === "photo" &&
        photoTimer !== null
      ) {
        photoRemaining = Math.max(
          0,
          photoRemaining -
            (Date.now() - photoStartedAt)
        );

        stopPhotoTimer();
      }

      if (active.kind === "video") {
        active.video.pause();
      }
    }

    function resumeCurrent() {
      if (!autoplay || isPaused()) return;

      if (!active) {
        activate();
        return;
      }

      if (active.finished) {
        next(version);
        return;
      }

      active.resume();
    }

    // =====================================
    // HOVER
    // =====================================

    function onEnter() {
      hovering = true;

      textElement.classList.add(
        "stop_move"
      );

      pauseCurrent();
    }

    function onLeave() {
      hovering = false;

      textElement.classList.remove(
        "stop_move"
      );

      resumeCurrent();
    }

    // =====================================
    // SAYFA GÖRÜNÜRLÜĞÜ
    // =====================================

    function onVisibility() {
      if (document.hidden) {
        pauseCurrent();
      } else {
        resumeCurrent();
      }
    }

    function onWindowLoad() {
      resumeCurrent();
    }

    // =====================================
    // RESPONSIVE KONTROL
    // =====================================

    function onResize() {
      if (
        !active ||
        active.kind !== "video"
      ) return;

      const slide =
        imageSwiper.slides[imageSwiper.activeIndex];

      if (
        slide &&
        selectVideo(slide) !== active.video
      ) {
        stopActive();
        activate();
      }
    }

    // =====================================
    // EVENT LISTENERS
    // =====================================

    if (autoplay && stopOnHover) {
      imageElement.addEventListener(
        "mouseenter",
        onEnter
      );

      imageElement.addEventListener(
        "mouseleave",
        onLeave
      );
    }

    document.addEventListener(
      "visibilitychange",
      onVisibility
    );

    window.addEventListener(
      "load",
      onWindowLoad
    );

    window.addEventListener(
      "pageshow",
      onWindowLoad
    );

    window.addEventListener(
      "resize",
      onResize
    );

    // =====================================
    // İLK VIDEO BAŞLATMA DÜZELTMESİ
    // =====================================

    // Swiper hazır olduğunda ilk aktif
    // bannerın video olaylarını hemen bağla.

    activate();

    // İlk açılışta başka bir tema işlemi
    // videoyu durdurursa kısa süre kontrol et.

    let startupChecks = 0;

    const startupWatch = setInterval(() => {
      if (
        disposed ||
        ++startupChecks > 12
      ) {
        clearInterval(startupWatch);
        return;
      }

      if (
        !imageSwiper ||
        imageSwiper.destroyed
      ) return;

      if (!active) {
        activate();
      } else if (
        active.kind === "video" &&
        !active.video.ended &&
        active.video.paused &&
        !isPaused()
      ) {
        active.resume();
      }
    }, 500);

    // =====================================
    // SHOPIFY EDITOR CLEANUP
    // =====================================

    initialized.set(element, () => {
      disposed = true;

      clearInterval(startupWatch);

      stopActive();

      imageElement.removeEventListener(
        "mouseenter",
        onEnter
      );

      imageElement.removeEventListener(
        "mouseleave",
        onLeave
      );

      document.removeEventListener(
        "visibilitychange",
        onVisibility
      );

      window.removeEventListener(
        "load",
        onWindowLoad
      );

      window.removeEventListener(
        "pageshow",
        onWindowLoad
      );

      window.removeEventListener(
        "resize",
        onResize
      );

      imageSwiper.destroy(true, true);
      textSwiper.destroy(true, true);
    });
  }

  // =====================================
  // BAŞLATMA
  // =====================================

  function initialize(root = document) {
    if (
      root.matches &&
      root.matches(".slideshow")
    ) {
      setup(root);
    }

    root.querySelectorAll(
      ".slideshow"
    ).forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initialize()
    );
  } else {
    initialize();
  }

  // =====================================
  // SHOPIFY SECTION EVENTS
  // =====================================

  document.addEventListener(
    "shopify:section:load",
    (event) => initialize(event.target)
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => {
      const elements = Array.from(
        event.target.querySelectorAll(
          ".slideshow"
        )
      );

      if (
        event.target.matches &&
        event.target.matches(".slideshow")
      ) {
        elements.unshift(event.target);
      }

      elements.forEach((element) => {
        const destroy = initialized.get(element);

        if (destroy) {
          destroy();
          initialized.delete(element);
        }
      });
    }
  );
})();
